import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import FJMobileFaceSwapFirstContainer from './FJMobileFaceSwapFirst/FJMobileFaceSwapFirstContainer';
import FJMobileFaceSwapSecondContainer from './FJMobileFaceSwapSecond/FJMobileFaceSwapSecondContainer';
import FJMobileFaceSwapThirdContainer from './FJMobileFaceSwapThird/FJMobileFaceSwapThirdContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import useLocalStore from '../../hooks/useLocalStore';
import { setSliceMobileStep } from '../../redux/slices/FJSliceFaceSwap';
import { setSliceMobileGenerateSuccessPreviewIndex, setSliceTaskStatusAction } from '../../redux/slices/FJSliceCommon';
import FJConstant from '../../constants/FJConstant';
import FJLocalStore from '../../store/FJLocalStore';
import FJMobileGenerateSuccessfulContainer from '../FJMainPreview/FJMobileGenerateSuccessful/FJMobileGenerateSuccessfulContainer';

const FJMobileFaceSwap = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const creationList = useSelector(state => state.common.creationList);
    const originUploadImageInfo = useSelector(state => state.faceSwap.originUploadImageInfo);

    const _gotoBack = useCallback(() => {
        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
    }, [dispatch]);

    const _onReEdit = () => {
        dispatch(setSliceMobileStep(0));
        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
    };
    const imageRect = useMemo(
        () => ({ width: originUploadImageInfo.width, height: originUploadImageInfo.height }),
        [originUploadImageInfo],
    );
    return (
        <>
            <FJMobileFaceSwapFirstContainer />
            <FJMobileFaceSwapSecondContainer />
            <FJMobileFaceSwapThirdContainer />
            <FJMobileHistoryContainer />
            <FJMobileGenerateSuccessfulContainer
                gotoBack={_gotoBack}
                onReEdit={_onReEdit}
                previewList={creationList}
                reEditText={FJLocalStore._('swap-more')}
                imageRect={imageRect}
                reEditHasUpload={false}
            />
        </>
    );
};
export default FJMobileFaceSwap;
